export default ($axios) => ({
  fetchLogs(query) {
    return $axios.get('/logs', { params: query }).then((response) => response.data);
  },
});
